import React from 'react'

const ServiceSections = () => {
  return (
    <>
      <section className="section-with-120px-margin">
        <div className="container">
          <div className="w-dyn-list">
            <div role="list" className="_4-column-grid w-dyn-items">
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99ad0eec4217342fa5c01_025-picture.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Concierge Service</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99ac49ac4656796540195_019-shop.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Guided City Tours</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99abac8367d3f598eb1e8_019-map.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Resort Packages</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99aacafcdc23ad4e2d756_018-beach.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Vacation Rentals</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99a9bcdcfe64dae292033_017-woman.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Rail Passes</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href="/service/flight-reservations"
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99a85862ec3d9e6e80d30_016-grill.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Flight Reservations</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99a764a226f7852543a2b_015-navigation.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Travel Insurance</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99a6423a1fb58c75322e6_013-ticket.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Tour Packages</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99a56cdcfe64dae28b428_013-group.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Car Rental</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99a47fdd0aea3fcb3746e_007-camping.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Cruise Booking</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99a3bfdd0aea3fcb3614b_004-browser.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Visa Assistance</h3>
                </a>
              </div>
              <div role="listitem" className="w-dyn-item">
                <a
                  data-w-id="1293ff8a-a617-7d88-9294-22afffc24454"
                  href=""
                  className="service-card w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6645ee4014275999f29/66b99820afcdc23ad4e030f3_001-photo.avif"
                    loading="lazy"
                    alt=""
                    className="image-65px"
                  />
                  <h3 className="_24px-text">Flight Booking</h3>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceSections
